import "./index.css"
import Pics from "./Pics";

export default function PageFive() {
    return (
        <div class="text-light">
            <h1 className="text-center mt-5">Lepton Music Cryptocurrency</h1>
            <div class="row">
                <div class="col-4">
                    <img src={require("../../images/coins.png")} height={400} width={300} className={"ms-5"}/>

                </div>
                <div class="col-8 mt-5">
                    Lepton Crypto Music Platform launches a DeFi system centered on LMC and LMG, to provide DeFi
                    services, based on open source technology and executed by smart contracts. Lending, depositing,
                    investing, trading and other activities on LeptonMusic Tokens are decentralized, automatic, open to
                    the public, and easily accessible for everyone. Let every music coin holder enjoy the convenience of
                    DeFi.
                </div>
            </div>
        </div>
    )
}